import { styled } from "@mui/material";

export const WalletStyled = styled("div")(({ isSelected = false }) => ({
  color: "#0F110C",
  borderRadius: "8px",
  padding: "16px",
  transition: ".3s",
  backgroundColor: "#F7F7F7",
  overflowX: "hidden",
  position: "relative",
}));

export const AddressStyled = styled("div")(() => ({
  display: "flex",
  alignItems: "center",
  gap: "8px",
  overflowX: "hidden",
}));

export const ContainerTitleWallet = styled("div")(() => ({
  display: "flex",
  alignItems: "center",
  gap: "8px",
  marginBottom: "8px",
}));
